import { useMemo, useState } from "react";
import { FCX, SelectSingle, Tooltip } from "@datassential/platform-ui-lib";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { FOODIES_CATEGORY_ID, useAuthorsCategories } from "@core/apiHooks/useAuthorsCategories";
import HeaderInfo from "@pages/TrendingNow/HeaderInfo";
import FoodiesSaying from "@pages/TrendingNow/FoodiesSaying/FoodiesSaying";
import './InfluencersSaying.scss';

const INFLUENCERS_TOOLTIP_ID = 'what-influencers-saying-info';

const InfluencersSaying: FCX = () => {
    const { data: categories, isLoading: isCategoriesLoading } = useAuthorsCategories();
    const [selectedInfluencerTypeId, setSelectedInfluencerTypeId] = useState<number | null>(null);

    const defaultInfluencerTypeId = useMemo(() => {
        const foodies = categories.find(({ id }) => id === FOODIES_CATEGORY_ID);
        return foodies?.id ?? categories[0]?.id ?? null;
    }, [categories]);

    const activeInfluencerTypeId = selectedInfluencerTypeId ?? defaultInfluencerTypeId;

    const options = useMemo(
        () => categories.map(({ id, name }) => ({ id, title: name })),
        [categories],
    );

    return (
        <div className="TrendingNow__wrapper">
            <div className="TrendingNow__section InfluencersSaying__header">
                <HeaderInfo text="WHAT INFLUENCERS ARE SAYING"/>
                <SelectSingle
                    className="InfluencersSaying__select"
                    value={activeInfluencerTypeId}
                    setValue={setSelectedInfluencerTypeId}
                    options={options}
                    dropdownProps={{ place: 'bottom-start' }}
                    testId="selectInfluencerType"
                />
                <AiOutlineInfoCircle
                    className="HeaderInfo__info-icon"
                    data-tooltip-id={INFLUENCERS_TOOLTIP_ID}
                />
                <Tooltip id={INFLUENCERS_TOOLTIP_ID} place="right">
                    An expert-curated panel of 1000+ chefs, influencers, home cooks, food lovers, and more
                </Tooltip>
            </div>
            {!isCategoriesLoading && (
                activeInfluencerTypeId !== null ? (
                    <div className="TrendingNow__section" data-testid="blockFoodiesSayingSection">
                        <FoodiesSaying influencerTypeId={activeInfluencerTypeId} isInfluencersView/>
                    </div>
                ) : (
                    <div className="TrendingNow__section InfluencersSaying__empty" data-testid="blockInfluencersSayingEmpty">
                        No influencer data is available right now.
                    </div>
                )
            )}
        </div>
    );
};

export default InfluencersSaying;
